import styled from "@xstyled/styled-components";

import { Paragraph, Spacing, Text } from "@otta/design";
import { palette } from "@otta/design-tokens";
import { Company } from "@otta/search/schema";
import { CircularImg } from "@otta/search/components/Img";
import { TooltipWithIcon } from "@otta/search/components/Tooltip";

const AuthorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;
`;

const AuthorContainer = styled.div`
  align-items: center;
  display: flex;
  gap: md;
`;

type Author = {
  name: string;
  title: string;
  image: string;
};

const stephPerson = {
  name: "Steph",
  title: "Company Specialist",
  image: "https://static.otta.com/images/headshots/Steph.webp",
} as Author;

const freddiePerson = {
  name: "Freddie",
  title: "Company Specialist",
  image: "https://static.otta.com/images/headshots/Freddie.webp",
} as Author;

const kirstyPerson = {
  name: "Kirsty",
  title: "Company Specialist",
  image: "https://static.otta.com/images/headshots/Kirsty.webp",
} as Author;

const carolinePerson = {
  name: "Caroline Fischer",
  title: "UK Country Manager",
  image: "https://static.otta.com/images/headshots/Caroline.jpg",
} as Author;

export const shouldDisplayOttasTake = (company: OttasTakeProps["company"]) => {
  return company.marketBullets.length > 0;
};

const people = [stephPerson, freddiePerson, kirstyPerson];
interface OttasTakeProps {
  company: Pick<Company, "marketBullets" | "name" | "id">;
  hasTitle?: boolean;
}

export function OttasTake({ company, hasTitle }: OttasTakeProps) {
  if (!shouldDisplayOttasTake(company)) {
    return null;
  }

  const { id, marketBullets } = company;

  const index = Number(id) % people.length;
  const person =
    id === "330" ? carolinePerson : people[isNaN(index) ? 2 : index];

  const authorTitle = (person: Author) => {
    return person !== carolinePerson
      ? `${person.title} at Welcome to the Jungle`
      : person.title;
  };

  return (
    <Spacing>
      {hasTitle && (
        <TooltipWithIcon
          content="This is our opinion, written to help you understand more about the company. It's not intended as a statement of fact, but was written to be as accurate as possible at the time of publishing"
          iconColor={palette.grayscale.shade600}
        >
          <Text bold as="h2" size={1} data-testid="ottas-take">
            Our take
          </Text>
        </TooltipWithIcon>
      )}
      <Spacing>
        {marketBullets.map(({ id, value }) => (
          <Paragraph data-testid="company-market-bullet" key={id}>
            {value}
          </Paragraph>
        ))}
      </Spacing>
      <AuthorContainer>
        <CircularImg
          src={person.image}
          alt={`${person.name} headshot`}
          width="56px"
        />
        <AuthorWrapper>
          <Text bold>{person.name}</Text>
          <Text>{authorTitle(person)}</Text>
        </AuthorWrapper>
      </AuthorContainer>
    </Spacing>
  );
}
